/* eslint-disable space-in-parens */
import React from 'react'
import PropTypes from 'prop-types'

class SearchMobile extends React.Component {
  static propTypes = {
    valueInit: PropTypes.string,
  }
  constructor (props) {
    super(props)
    window.pro4 = this.state
    this.handleGo = this.handleGo.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.state = {
      search: this.props.valueInit
    }
  }

  handleChange (event) {
    this.setState({ search: event.target.value })
  }
  handleGo (event) {
    window.location.href = '/tim-kiem/' + this.state.search
    event.preventDefault()
    return false
  }

  render () {
    return (
      <section className='advanced-search-mobile visible-xs visible-sm'>
        <div className='container'>
          <div className='row'>
            <div className='col-sm-12'>
              <form>
                <div className='single-search-wrap'>
                  <div className='single-search-inner advance-btn'>
                    <button className='table-cell text-left' type='button'><i className='fa fa-gear' /></button>
                  </div>
                  <div className='single-search-inner single-search'>

                    <input type='text' className='form-control table-cell' name='search'
                      value={this.state.search} placeholder='Tìm kiếm' onChange={this.handleChange} />
                  </div>
                  <div className='single-search-inner single-seach-btn'>
                    <button onClick={this.handleGo} className='table-cell text-right'><i className='fa fa-search' /></button>
                  </div>
                </div>

                {/*<div className='advance-fields'>*/}
                  {/*<div className='row'>*/}
                    {/*<div className='col-sm-6 col-xs-12'>*/}
                      {/*<div className='form-group'>*/}
                        {/*<select className='selectpicker' data-live-search='false' data-live-search-style='begins'*/}
                          {/*title='All Cities'>*/}
                          {/*<option>City 1</option>*/}
                          {/*<option>City 2</option>*/}
                          {/*<option>City 3</option>*/}
                          {/*<option>City 4</option>*/}
                          {/*<option>City 5</option>*/}
                        {/*</select>*/}
                      {/*</div>*/}
                    {/*</div>*/}
                    {/*<div className='col-sm-6 col-xs-12'>*/}
                      {/*<div className='form-group'>*/}
                        {/*<select className='selectpicker' data-live-search='false' data-live-search-style='begins'*/}
                          {/*title='All Areas'>*/}
                          {/*<option>Area 1</option>*/}
                          {/*<option>Area 2</option>*/}
                          {/*<option>Area 3</option>*/}
                          {/*<option>Area 4</option>*/}
                          {/*<option>Area 5</option>*/}
                        {/*</select>*/}
                      {/*</div>*/}
                    {/*</div>*/}
                    {/*<div className='col-sm-6 col-xs-12'>*/}
                      {/*<div className='form-group'>*/}
                        {/*<select className='selectpicker' data-live-search='false' data-live-search-style='begins'*/}
                          {/*title='All Status'>*/}
                          {/*<option>Status 1</option>*/}
                          {/*<option>Status 2</option>*/}
                          {/*<option>Status 3</option>*/}
                          {/*<option>Status 4</option>*/}
                          {/*<option>Status 5</option>*/}
                        {/*</select>*/}
                      {/*</div>*/}
                    {/*</div>*/}
                    {/*<div className='col-sm-6 col-xs-12'>*/}
                      {/*<div className='form-group'>*/}
                        {/*<select className='selectpicker' data-live-search='false' data-live-search-style='begins'*/}
                          {/*title='All Types'>*/}
                          {/*<option>Type 1</option>*/}
                          {/*<option>Type 2</option>*/}
                          {/*<option>Type 3</option>*/}
                          {/*<option>Type 4</option>*/}
                          {/*<option>Type 5</option>*/}
                        {/*</select>*/}
                      {/*</div>*/}
                    {/*</div>*/}
                    {/*<div className='col-sm-6 col-xs-6'>*/}
                      {/*<div className='form-group'>*/}
                        {/*<div className='input-group'>*/}
                          {/*<span className='input-group-btn'>*/}
                            {/*<button type='button' className='btn btn-number' disabled='disabled' data-type='minus'*/}
                              {/*data-field='count_beds'>*/}
                              {/*<i className='fa fa-minus' />*/}
                            {/*</button>*/}
                          {/*</span>*/}
                          {/*<input type='text' name='count_beds' className='form-control input-number' value='1'*/}
                            {/*data-min='1' data-max='10' placeholder='Beds' />*/}
                          {/*<span className='input-group-btn'>*/}
                            {/*<button type='button' className='btn btn-number' data-type='plus' data-field='count_beds'>*/}
                              {/*<i className='fa fa-plus' />*/}
                            {/*</button>*/}
                          {/*</span>*/}
                        {/*</div>*/}
                      {/*</div>*/}
                    {/*</div>*/}
                    {/*<div className='col-sm-6 col-xs-6'>*/}
                      {/*<div className='form-group'>*/}
                        {/*<div className='input-group'>*/}
                          {/*<span className='input-group-btn'>*/}
                            {/*<button type='button' className='btn btn-number' disabled='disabled' data-type='minus'*/}
                              {/*data-field='count_baths'>*/}
                              {/*<i className='fa fa-minus' />*/}
                            {/*</button>*/}
                          {/*</span>*/}
                          {/*<input type='text' name='count_baths' className='form-control input-number' value='1'*/}
                            {/*data-min='1' data-max='10' placeholder='Baths' />*/}
                          {/*<span className='input-group-btn'>*/}
                            {/*<button type='button' className='btn btn-number' data-type='plus' data-field='count_baths'>*/}
                              {/*<i className='fa fa-plus' />*/}
                            {/*</button>*/}
                          {/*</span>*/}
                        {/*</div>*/}
                      {/*</div>*/}
                    {/*</div>*/}
                    {/*<div className='col-sm-6 col-xs-6'>*/}
                      {/*<div className='form-group'>*/}
                        {/*<input type='text' className='form-control' value='' name='min-area'*/}
                          {/*placeholder='Min Area (sqft)' />*/}
                      {/*</div>*/}
                    {/*</div>*/}
                    {/*<div className='col-sm-6 col-xs-6'>*/}
                      {/*<div className='form-group'>*/}
                        {/*<input type='text' className='form-control' value='' name='max-area'*/}
                          {/*placeholder='Max Area (sqft)' />*/}
                      {/*</div>*/}
                    {/*</div>*/}
                    {/*<div className='col-sm-12 col-xs-12'>*/}
                      {/*<div className='range-advanced-main'>*/}
                        {/*<div className='range-text'>*/}
                          {/*<input type='text' className='min-price-range-hidden range-input' />*/}
                          {/*<input type='text' className='max-price-range-hidden range-input' />*/}
                          {/*<p>*/}
                            {/*<span className='range-title'>Price Range:</span> from*/}
                            {/*<span className='min-price-range' /> to*/}
                            {/*<span className='max-price-range' />*/}
                          {/*</p>*/}
                        {/*</div>*/}
                        {/*<div className='range-wrap'>*/}
                          {/*<div className='price-range-advanced' />*/}
                        {/*</div>*/}
                      {/*</div>*/}
                    {/*</div>*/}
                    {/*<div className='col-sm-12 col-xs-12'>*/}
                      {/*<label className='advance-trigger'><i className='fa fa-plus-square' /> Other Features </label>*/}
                    {/*</div>*/}
                    {/*<div className='col-sm-12 col-xs-12 features-list '>*/}
                      {/*<div className='field-expand'>*/}
                        {/*<label className='checkbox-inline'>*/}
                          {/*<input type='checkbox' value='option1' /> Feature*/}
                        {/*</label>*/}
                        {/*<label className='checkbox-inline'>*/}
                          {/*<input type='checkbox' value='option2' /> Feature*/}
                        {/*</label>*/}
                        {/*<label className='checkbox-inline'>*/}
                          {/*<input type='checkbox' value='option3' /> Feature*/}
                        {/*</label>*/}
                        {/*<label className='checkbox-inline'>*/}
                          {/*<input type='checkbox' value='option1' /> Feature*/}
                        {/*</label>*/}
                        {/*<label className='checkbox-inline'>*/}
                          {/*<input type='checkbox' value='option2' /> Feature*/}
                        {/*</label>*/}
                        {/*<label className='checkbox-inline'>*/}
                          {/*<input type='checkbox' value='option3' /> Feature*/}
                        {/*</label>*/}
                        {/*<label className='checkbox-inline'>*/}
                          {/*<input type='checkbox' value='option1' /> Feature*/}
                        {/*</label>*/}
                        {/*<label className='checkbox-inline'>*/}
                          {/*<input type='checkbox' value='option2' /> Feature*/}
                        {/*</label>*/}
                        {/*<label className='checkbox-inline'>*/}
                          {/*<input type='checkbox' value='option3' /> Feature*/}
                        {/*</label>*/}
                        {/*<label className='checkbox-inline'>*/}
                          {/*<input type='checkbox' value='option1' /> Feature*/}
                        {/*</label>*/}
                        {/*<label className='checkbox-inline'>*/}
                          {/*<input type='checkbox' value='option2' /> Feature*/}
                        {/*</label>*/}
                        {/*<label className='checkbox-inline'>*/}
                          {/*<input type='checkbox' value='option3' /> Feature*/}
                        {/*</label>*/}
                      {/*</div>*/}
                    {/*</div>*/}
                    {/*<div className='col-sm-12 col-xs-12'>*/}
                      {/*<button onClick={this.handleGo} className='btn btn-secondary btn-block'>*/}
                        {/*<i className='fa fa-search pull-left' /> Tìm kiếm</button>*/}
                    {/*</div>*/}
                  {/*</div>*/}
                {/*</div>*/}
              </form>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default SearchMobile



// WEBPACK FOOTER //
// ./src/components/SearchMobile.js